// src/constants/dietaryTags.js
// Single source of truth for dietary tag values across the Nutrius web platform.
// Must stay in sync with the iOS DietaryTag system.

export const DIETARY_TAGS = [
  'Gluten-Free',
  'Vegan',
  'Vegetarian',
  'Dairy-Free',
  'Nut-Free',
  'Keto',
  'Paleo',
  'Halal',
  'Kosher',
  'Low-Carb',
  'Low-Sodium',
  'Egg-Free',
  'Soy-Free',
  'Sugar-Free',
];
